<template>
<a href="#" v-if="type !== 'sound'" :class="classes" v-sharebox="{'service':this.type, 'opts':getShareInfos()}">
  <!-- <img class="sharing__btn__img" src="/static/assets/img/btn_facebook_black.png" alt="Partage Facebook" v-if="type == 'facebook'">
      <img class="sharing__btn__img" src="/static/assets/img/btn_twitter_black.png" alt="Partage Twitter" v-else> -->
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 33 33.2" style="enable-background:new 0 0 33 33.2;" xml:space="preserve" height="34px" width="33px"
    @mouseenter="onMouseEnter()"
    @touchstart="onMouseEnter()"
    @mouseleave="onMouseLeave()"
    @touchend="onMouseLeave()"
  >
    <path v-if="type == 'facebook'" class="icon" d="M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z
         M20.6,17.2h-2.7v9.6h-4v-9.6H12v-3.4h1.9v-2.2c0-1.6,0.7-4,4-4l2.9,0v3.3h-2.1c-0.4,0-0.8,0.2-0.8,0.9v2h3L20.6,17.2z" />
    <path v-if="type == 'twitter'" class="icon" d="M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z
         M23.8,12.8c0,0.2,0,0.3,0,0.5c0,5-3.8,10.9-10.8,10.9c-2.1,0-4.1-0.6-5.8-1.7c0.3,0,0.6,0.1,0.9,0.1c1.8,0,3.4-0.6,4.7-1.6
         c-1.7,0-3.1-1.1-3.5-2.7c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.7,0,1-0.1c-1.7-0.3-3-1.9-3-3.7c0,0,0,0,0,0c0.5,0.3,1.1,0.5,1.7,0.5
         C8.7,14.1,8,13,8,11.6c0-0.7,0.2-1.4,0.5-1.9c1.9,2.3,4.7,3.8,7.8,4c-0.1-0.3-0.1-0.6-0.1-0.9C16.3,10.7,18,9,20,9
         c1.1,0,2.1,0.5,2.8,1.2c0.9-0.2,1.7-0.5,2.4-0.9c-0.3,0.9-0.9,1.6-1.7,2.1c0.8-0.1,1.5-0.3,2.2-0.6C25.2,11.6,24.6,12.2,23.8,12.8
         z" />
    </svg>
</a>
<div v-else :class="classes">
  <svg  v-on:click="toggleSound" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 33 33.2" style="enable-background:new 0 0 33 33.2;" xml:space="preserve" height="34px" width="33px"
    @mouseenter="onMouseEnter()"
    @touchstart="onMouseEnter()"
    @mouseleave="onMouseLeave()"
    @touchend="onMouseLeave()"
  >
    <path v-show="!muted" class="icon" d="M16.5,0C7.4,0,0,7.4,0,16.6c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z
        M16,22.3c0,0.4-0.2,0.7-0.5,0.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.6-0.2l-5-4.1H6.9c-0.5,0-0.9-0.4-0.9-0.9v-3.6
        c0-0.5,0.4-0.9,0.9-0.9h2.6l5-4.1c0.3-0.2,0.6-0.3,1-0.1C15.8,9.2,16,9.6,16,9.9V22.3z M19.5,20.8C19.5,20.8,19.4,20.8,19.5,20.8
        c-0.3,0-0.5-0.1-0.7-0.3l-0.1-0.1c-0.3-0.3-0.4-0.8-0.1-1.2c0.7-0.9,1-2,1-3.2c0-1.2-0.4-2.4-1.2-3.4c-0.3-0.4-0.3-0.9,0.1-1.2
        l0.1-0.1c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c1.1,1.3,1.6,2.9,1.6,4.6c0,1.6-0.5,3.1-1.4,4.4
        C20,20.7,19.8,20.8,19.5,20.8z M23.2,23.7c-0.2,0.2-0.4,0.3-0.7,0.3c0,0,0,0,0,0c-0.2,0-0.5-0.1-0.6-0.3l-0.1-0.1
        c-0.3-0.3-0.4-0.9-0.1-1.2c1.5-1.8,2.3-4,2.3-6.3c0-2.4-0.9-4.7-2.4-6.5c-0.3-0.4-0.3-0.9,0-1.3l0.1-0.1C21.9,8.1,22.1,8,22.4,8
        c0.2,0,0.5,0.1,0.7,0.3c1.9,2.1,2.9,4.9,2.9,7.8C26,18.9,25,21.6,23.2,23.7z" />
    <path v-show="muted" class="icon" d="M16.5,0C7.4,0,0,7.4,0,16.6
          c0,9.1,7.4,16.6,16.5,16.6c9.1,0,16.5-7.4,16.5-16.6C33,7.4,25.6,0,16.5,0z M16,22.3c0,0.4-0.2,0.7-0.5,0.8
          c-0.1,0.1-0.3,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.6-0.2l-5-4.1H6.9c-0.5,0-0.9-0.4-0.9-0.9v-3.6c0-0.5,0.4-0.9,0.9-0.9h2.6l5-4.1
          c0.3-0.2,0.6-0.3,1-0.1C15.8,9.2,16,9.6,16,9.9V22.3z M23.4,18.8c-0.4,0.4-1,0.4-1.4,0l-1.3-1.3l-1.3,1.3c-0.4,0.4-1,0.4-1.4,0
          c-0.4-0.4-0.4-1,0-1.4l1.3-1.3L18,14.8c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.3,1.3l1.3-1.3c0.4-0.4,1-0.4,1.4,0
          c0.4,0.4,0.4,1,0,1.4l-1.3,1.3l1.3,1.3C23.8,17.8,23.8,18.4,23.4,18.8z" />

    </svg>
</div>
</template>

<script>
// import 'styles/components/ui-button.styl'
import Emitter from 'core/Emitter'
import TweenMax from 'gsap'
import VueShareBox from 'plugins/VueShareBox'
export default {
  name: 'button',
  data () {
    return {
      muted: false
    }
  },
  props: [
    'type',
    'shareInfos',
    'isTransparent'
  ],
  computed: {
    classes () {
      let c = {}
      let parentClass = this.$parent.$options.name === 'single-plant' ? 'sharing__btn' : 'menu__btn'
      if (this.type === 'facebook') {
        c[`${parentClass}--fb`] = true
      } else if (this.type === 'twitter') {
        c[`${parentClass}--twitter`] = true
      }
      c[parentClass] = true

      return c
    }
  },
  mounted () {
    this.addListeners()
    this.circleEl = this.$el.querySelector('.circle')
    this.icons = this.$el.querySelectorAll('.icon')
    this.svgEl = this.$el.querySelector('.sharing__btn__img') || this.$el

    for (var icon of this.icons) {
      icon.style.fill = this.$route.name === 'single-plant' ? 'rgb(0, 0, 0)' : 'rgb(255, 255, 255)'
    }
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    addListeners () {
      Emitter.on('MENU_BLACK_BTNS', this.setButtonBlack)
      Emitter.on('SET_MENU_TRANSPARENT', this.setButtonWhite)
    },

    removeListeners () {
      Emitter.removeListener('MENU_BLACK_BTNS', this.setButtonBlack)
      Emitter.removeListener('SET_MENU_TRANSPARENT', this.setButtonWhite)
    },

    setButtonWhite () {
      for (var icon of this.icons) {
        icon.style.fill = 'rgb(255, 255, 255)'
      }
    },

    setButtonBlack () {
      for (var icon of this.icons) {
        icon.style.fill = 'rgb(0, 0, 0)'
      }
    },

    toggleSound () {
      this.muted = !this.muted
      Emitter.emit('SOUND::TOGGLE_SOUND', {
        muted: !this.muted,
        sender: 'toggleSound'
      })
    },

    getShareInfos () {
      return this.shareInfos
    },
    onMouseEnter () {
      Emitter.emit('SOUND::PLAY_UI_CLICK')
      let tl = new TimelineMax()
      // tl.to(this.circleEl, 0.5, {
      //   transformOrigin: '50% 50%',
      //   scale: 1.6,
      //   // transformOrigin: '50% 50%',
      //   ease: Back.easeOut
      // }, 'start')
      // .to(this.icons, 0.4, {
      //   transformOrigin: '50% 50%',
      //   scale: 1.15,
      //   ease: Quint.easeOut
      // }, 'start')
      tl.to(this.icons, 0.5, {
        transformOrigin: '50% 50%',
        scale: 0.93,
        // transformOrigin: '50% 50%',
        ease: Expo.easeOut
      }, 'start')
    },

    onMouseLeave () {
      let tl = new TimelineMax()
      // tl.to(this.circleEl, 0.6, {
      //   transformOrigin: '50% 50%',
      //   scale: 1,
      //   ease: Quint.easeOut
      // }, 'start')
      // .to(this.icons, 0.4, {
      //   transformOrigin: '50% 50%',
      //   scale: 1,
      //   ease: Quint.easeOut
      // }, 'start')
      tl.to(this.icons, 0.6, {
        transformOrigin: '50% 50%',
        scale: 1,
        ease: Quint.easeOut
      }, 'start')
    },

    pushTheButton () {
      // let tl = new TimelineMax()
      // tl.to(this.circleEl, 0.3, {
      //   transformOrigin: '50% 50%',
      //   scale: 1.3,
      //   ease: Sine.easeOut
      // }, 'first')
      // .to(this.circleEl, 0.4, {
      //   transformOrigin: '50% 50%',
      //   scale: 1.6,
      //   ease: Quint.easeOut
      // }, 'second')
      // .to(this.icons, 0.4, {
      //   transformOrigin: '50% 50%',
      //   scale: 0.8,
      //   ease: Quint.easeOut
      // }, 'first')
      // .to(this.icons, 0.4, {
      //   transformOrigin: '50% 50%',
      //   scale: 1.15,
      //   ease: Quint.easeOut
      // }, 'second')
    }

  }
}
</script>



/** WEBPACK FOOTER **
 ** Button.vue?424e0d69
 **/